var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 11.7L14 11.7C14 11.7 13.8336 9.7 11.9998 9.7C10.5 9.7 9.66049 10.731 9.5 11.7ZM9.5 11.7C9.15841 13.7672 10.5 14.7 11.9998 14.7C13.4995 14.7 14 13.7 14 13.7M12 6.04201C10.3516 4.56337 8.2144 3.74695 6 3.75001C4.948 3.75001 3.938 3.93001 3 4.26201V18.512C3.96362 18.172 4.97816 17.9989 6 18C8.305 18 10.408 18.867 12 20.292C13.6484 18.8134 15.7856 17.997 18 18C19.0218 17.9989 20.0364 18.172 21 18.512V4.26201C20.062 3.93001 19.052 3.75001 18 3.75001C15.7856 3.74686 13.6483 4.56328 12 6.04201Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.f1922ce6f5ff4fcc12fae6b0db67b68b.svg";
export { ForwardRef as ReactComponent };